<div class="flex items-center justify-between mt-6 gap-2 px-5 py-4">
    <div (click)="onPageChange((currentPage - 1).toString())"
        class="flex items-center justify-center rounded-lg text-gray-ds-900 cursor-pointer">
        <span class="text-[13px] leading-7 font-medium">قبلی</span>
    </div>
    <ul class="flex items-center justify-center lg:gap-2">
        <li (click)="onPageChange(item)" [ngClass]="{
       'bg-white-700 !text-gray-900 !cursor-default': currentPage === +item,
       '!cursor-default': item === '...'
      }" *ngFor="let item of this.pages"
            class="w-10 h-10 flex items-center justify-center rounded-lg text-gray-ds-300 cursor-pointer">
            {{ item }}
        </li>
    
    </ul>
    <div (click)="onPageChange((currentPage + 1).toString())"
        class="flex items-center justify-center rounded-lg text-gray-ds-900 cursor-pointer">
        <span class="text-[13px] leading-7 font-medium">بعدی</span>
    </div>
</div>